import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"


import { ref, onMounted, computed } from 'vue'
import { FollowAlarmParams } from '@/typings/api/analysis'
import { followAlarmGet } from '@/api/overseasSales/analysis'
import { listByParamCodes } from '@/api/common'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import { useI18n } from 'vue-i18n'
import { alarmTypeEnum, alarmLevelEnum, alarmCustomerLevelEnum, alarmProcessStatusEnum } from '@/views/overseasSales/commonEnum/dataConfig'
const __default__ = { name: 'ofbu_followChangeFeedback' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const searchFrom = ref<FollowAlarmParams>({})
const paramCodeData = ref<any>({
  ofbu_change_description: [] // 异动说明
})
const columns = computed(() => [
  {
    title: t('custom.customerNumber'),
    dataIndex: 'customerNumber',
    fixed: 'left',
    width: 200
  },
  {
    title: t('custom.customerName'),
    dataIndex: 'customerName'
  },
  {
    title: t('arkCode.arkCode'),
    dataIndex: 'arkCode'
  },
  {
    title: t('exception.sellerName'),
    dataIndex: 'sellerName'
  },
  {
    title: t('exception.exceptionTime'),
    dataIndex: 'alarmDate'
  },
  {
    title: t('exception.exceptionLevel'),
    dataIndex: 'alarmLevel',
    dicData: alarmLevelEnum
  },
  {
    title: t('custom.customerLevel'),
    dataIndex: 'customerLevel',
    dicData: alarmCustomerLevelEnum
  },
  {
    title: t('exception.exceptionType'),
    dataIndex: 'alarmType',
    dicData: alarmTypeEnum
  },
  {
    title: t('exception.exceptionReason'),
    dataIndex: 'alarmInfo'
  },
  {
    title: t('exception.exceptionDes'),
    dataIndex: 'alarmDesc',
    dicData: paramCodeData.value.ofbu_change_description
  },
  {
    title: t('follow.processDetail'),
    dataIndex: 'process'
  },
  {
    title: t('exception.followUpTime'),
    dataIndex: 'processTime'
  },
  {
    title: t('exception.followUpDes'),
    dataIndex: 'processStatus',
    dicData: alarmProcessStatusEnum
  }
])
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_change_description']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const fetch = (params: FollowAlarmParams, callBack: (res: any) => void) => {
  followAlarmGet({
    ...params
  }).then((res) => {
    callBack(res)
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            columns: columns.value,
            search: searchFrom.value,
            "onUpdate:search": _cache[9] || (_cache[9] = ($event: any) => ((searchFrom).value = $event)),
            onFetch: fetch,
            tableId: "ofbuFollowChangeFeedback"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.customerNumber')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerNumber,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.customerNumber) = $event)),
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.arkCode')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.arkCode,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.arkCode) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('custom.customerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "createTime",
                    label: _unref(t)('exception.exceptionTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosRangePicker, {
                        isOutputBeijingTime: "",
                        startTime: searchFrom.value.startAlarmDate,
                        "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.startAlarmDate) = $event)),
                        endTime: searchFrom.value.endAlarmDate,
                        "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.endAlarmDate) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "seller",
                    label: _unref(t)('exception.sellerName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_user_select, {
                        value: searchFrom.value.seller,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.seller) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('exception.exceptionType')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: searchFrom.value.alarmType,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.alarmType) = $event)),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: "",
                        options: _unref(alarmTypeEnum)
                      }, null, 8, ["value", "placeholder", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('exception.exceptionLevel')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: searchFrom.value.alarmLevelList,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.alarmLevelList) = $event)),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        mode: "multiple",
                        allowClear: "",
                        options: _unref(alarmLevelEnum)
                      }, null, 8, ["value", "placeholder", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('exception.followUpDes')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: searchFrom.value.processStatusList,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom.value.processStatusList) = $event)),
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: "",
                        mode: "multiple",
                        options: _unref(alarmProcessStatusEnum)
                      }, null, 8, ["value", "placeholder", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_ofbu",
                taskType: "413",
                search: searchFrom.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'ofbu_followChangeFeedback_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, text }) => [
              (column.dataIndex === 'process')
                ? (_openBlock(), _createBlock(EditorTableText, {
                    key: 0,
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})